module.exports = __webpack_public_path__ + "static/img/heart.bf89e80.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/emotions/emoji/heart.png
// module id = v4E1
// module chunks = 0